<template>
  <div>
    <v-row class="mt-0">
      <v-col cols="12" class="d-flex pb-0">
        <v-col cols="4">
          <!-- create payout record -->
          <!-- <v-btn color="secondary" @click="openCreateCogsEstimateModal()">
            <v-icon left>mdi-newspaper-plus</v-icon>Create
          </v-btn> -->
          <!-- Reload button -->
          <v-btn color="secondary" @click.stop="reload()">
            <i class="fa fa-repeat fa-xs"></i>&nbsp;Reload
          </v-btn>
          <!-- export excel -->
          <v-btn color="secondary" @click="downloadCogsEstimateRpt"><v-icon small>download</v-icon> Export Excel</v-btn>
        </v-col>
        <!-- <v-btn @click="resetFilter" class="ml-2"  style="float: right">Reset Filters</v-btn> -->
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" class="d-flex pb-0">
        <v-col cols="12">
          <div class="d-flex flex-wrap" style="justify-content:right">
            <!-- <v-checkbox
              class="mt-0 pr-4"
              v-model="selectedFilter.batchOne"
              label="Batch 1"
              color="secondary"
              :value="false"
              hide-details
              @change="getCogsEstimation()"
            ></v-checkbox>
            <v-checkbox
              class="mt-0 pr-4"
              v-model="selectedFilter.batchTwo"
              label="Batch 2"
              color="secondary"
              :value="false"
              hide-details
              @change="getCogsEstimation()"
            ></v-checkbox>
            <v-checkbox
              class="mt-0 pr-4"
              v-model="selectedFilter.createdOnly"
              label="Created Only"
              color="secondary"
              :value="false"
              hide-details
              @change="getCogsEstimation()"
            ></v-checkbox> -->
            <v-combobox
              class="pr-2"
              style="min-width:200px;max-width:200px;"
              v-model="selectedFilter.country"
              :items="countries"
              hide-selected
              multiple            
              clearable
              small-chips
              outlined
              dense
              hide-details="auto"
              label="Country"                 
            >
              <template v-slot:selection="data">
                <v-chip :input-value="data.selected" close @click:close="remove(data.item)">
                  <strong>{{ data.item }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-combobox>
            <div class="mr-2" style="max-width:200px">
              <v-autocomplete
                label="All CC"
                v-model="selectedFilter.cc"
                :items="CCUsers"
                item-text="name"
                item-value="id"
                @change="getCogsEstimation()"
                dense
                outlined
                hide-details
              >
              </v-autocomplete>
            </div>
            <v-menu
              ref="startDatePicker"
              v-model="startDateCal"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              dense
              max-width="350px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  style="min-width:200px;max-width:200px;"
                  label="Start Month"
                  placeholdre="Start Month"
                  v-model="startDate"
                  dense
                  readonly
                  outlined
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                type="month"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <!-- <v-btn
                    text
                    color="secondary"
                    @click="cancelStartMonth()"
                >
                    Cancel
                </v-btn> -->
                <!-- <v-btn
                    text
                    color="secondary"
                    @click="searchStartMonthOk()"
                >
                    OK
                </v-btn> -->
              </v-date-picker>
            </v-menu>
            <span class="date-divider"> - </span>
            <v-menu
              ref="endDatePicker"
              v-model="endDateCal"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              dense
              max-width="350px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="mr-3"
                  style="min-width:200px;max-width:200px;"
                  label="End Month"
                  placeholder="End Month"
                  v-model="endDate"
                  dense
                  readonly
                  outlined
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                type="month"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <!-- <v-btn
                    text
                    color="secondary"
                    @click="cancelEndMonth()"
                >
                    Cancel
                </v-btn> -->
                <!-- <v-btn
                    text
                    color="secondary"
                    @click="searchEndMonthOk()"
                >
                    OK
                </v-btn> -->
              </v-date-picker>
            </v-menu>
          </div>
        </v-col>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" class="d-flex pb-0">
        <v-col cols="12">
          <div class="d-flex flex-wrap" style="justify-content:right">
            <v-text-field style="max-width:250px;" class="pt-0" v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
            <v-btn @click="getCogsEstimation" color="secondary" class="ml-2">Apply</v-btn>
          </div>
        </v-col>
      </v-col>
    </v-row>
    <div class="d-flex flex-row mt-3" style="justify-content:space-between;margin:0;padding:0;">
      <v-flex md4 sm4 xs12 pa-3>
        <v-card dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">Estimated COGS for {{currentMonthLabel}}</v-card-title>
          <v-card-text>
            <p class="ma-0 pa-0 h3">${{currentMthCOGS | thousandSeprator}}</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md4 sm4 xs12 pa-3>
        <v-card dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">Estimated COGS for {{nextMonthLabel}}</v-card-title>
          <v-card-text>
            <p class="ma-0 pa-0 h3">${{nextMthCOGS | thousandSeprator}}</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md4 sm4 xs12 pa-3>
        <v-card dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">Estimated COGS {{showFilterDate}}</v-card-title>
          <v-card-text>
            <p class="ma-0 pa-0 h3">${{totalValues.cogsEstimate | thousandSeprator}}</p>
          </v-card-text>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              text
              @click="openMoreDetailsDialog"
            >
              More Details
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </div>
    <div>
      <div class="text-right">
        <v-menu
          :close-on-content-click="false"
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="secondary"
              v-bind="attrs"
              v-on="on"
              @click="openColSettingsModal"
            >
              <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
            </v-btn>
          </template>
        </v-menu>
      </div>
      <div class="campaign-cogs-section" :id="item.name" v-for="(item, index) in monthsData" :key="index">
        <v-expansion-panels class="expansion-panels mb-5" v-model="item.panel" multiple accordion>
          <v-expansion-panel class="expansion-panel-main" expand>
            <v-expansion-panel-header class="expansion-panel-header">
              <h3 class="pa-0 ma-0">{{formatTitle(item.month)}}</h3>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="expansion-panel-content">
              <v-row class="no-gutters">
                <v-col cols="12" sm="12" md="12" lg="12">
                <v-row class="action-section mb-3">
                    <v-col class="action-group-section pl-0" cols="12" sm="3" md="3" lg="3">
                      <div class="d-flex flex-row" style="gap:3px">
                        <div>
                          <v-btn
                            class="mb-2"
                            color="warning"
                            small
                            v-if="item.selectedCOGS && item.selectedCOGS.length > 0"
                            @click="openTotalSummaryDialog(item.selectedCOGS)"
                          >View Summary ({{item.selectedCOGS.length}})</v-btn>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="9" md="9" lg="9">
                      <div class="d-flex justify-content-right float-right">
                        <div class="mx-2" style="min-width:150px">
                          <v-text-field
                            v-model="item.filter"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                          ></v-text-field>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-data-table
                  ref="CreatorCogsTable"
                  :headers="computedHeaders"
                  :search="item.filter"
                  :items="item.data"
                  :items-per-page="15"
                  class="creator-cogs-table elevation-1"
                  show-select
                  :single-select="false"
                  v-model="item.selectedCOGS"
                  @current-items="getFiltered">
                    <template v-slot:[`item.estimatedLiveDate`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'" style="min-width:100px!important">
                        <span v-if="item.estimatedLiveDate">{{item.estimatedLiveDate ? formatYM(item.estimatedLiveDate) : ''}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.liveDate`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'" style="min-width:100px!important">
                        <span v-if="item.liveDate && item.liveDate !== 'Invalid date'">{{item.liveDate ? formatDate(item.liveDate) : ''}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.submissionDate`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'" style="min-width:100px!important">
                        <span v-if="item.submissionDate">{{formatDMY(item.submissionDate) !== 'Invalid date' ? formatDMY(item.submissionDate) : ''}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.handle`]="{ item }">
                      <div :class="item.duplicate ? 'text-duplicate' : ''" v-if="item.handle">
                        <social-handle
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isOthers="item.platform === 'others'"
                          :tiktokHandle="item.handle"
                          :instagramHandle="item.handle"
                          :youtubeHandle="item.handle"
                          :otherHandle="item.handle"
                        />
                      </div>
                    </template>
                    <template v-slot:[`item.country`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'" style="min-width:100px!important">
                        <span v-if="item.country">{{item.country}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.bankName`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'" style="min-width:100px!important">
                        <span v-if="item.bankName">{{item.bankName}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.swiftCode`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'" style="min-width:100px!important">
                        <span v-if="item.swiftCode">{{item.swiftCode}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.bankAccount`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'" style="min-width:100px!important">
                        <span v-if="item.bankAccount">{{item.bankAccount}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.username`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'">
                        <span v-if="item.username">{{item.username}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.email`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'">
                        <span v-if="item.email">{{item.email}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.amount`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-left' : 'text-left'" style="min-width:120px">
                        <span v-if="!item.pairing && (item.amount || item.amount === 0)">${{item.amount | thousandSeprator}}</span>
                        <span v-if="item.pairing && item.GSTpercent">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <div v-on="on">
                              {{utilsFunc.currencySym(item.currency)}} {{(item.amount - item.GSTpercent) | thousandSeprator}}
                              </div>
                            </template>
                            <span>{{item.currency}} {{(item.amount - item.GSTpercent) | thousandSeprator}}</span>
                          </v-tooltip>
                        </span>
                        <span v-if="item.pairing && !item.GSTpercent">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <div v-on="on">
                                {{utilsFunc.currencySym(item.currency)}} {{item.amount | thousandSeprator}}
                              </div>
                            </template>
                            <span>{{item.currency}} {{item.amount | thousandSeprator}}</span><br>
                            <span v-if="item.sgdAmt">Estimate SGD: {{item.sgdAmt}}</span>
                          </v-tooltip>
                        </span>
                        <!-- <v-icon small color="green" data-toggle="tooltip" data-placement="bottom" title="Created" v-if="item.created">mdi-folder-plus-outline</v-icon>
                        <v-icon small color="warning" data-toggle="tooltip" data-placement="bottom" title="Imported" v-if="item.imported">mdi-newspaper-plus</v-icon> -->
                      </td>
                    </template>
                    <template v-slot:[`item.GSTAmount`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'" style="min-width:80px!important">
                        <span v-if="item.GSTAmount">${{item.GSTAmount}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.GSTExcludedAmt`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'">
                        <!-- <span v-if="item.GSTExcludedAmt || item.GSTExcludedAmt === 0">${{item.GSTExcludedAmt}}</span> -->
                        <span v-if="item.GSTExcludedAmt || item.GSTExcludedAmt === 0">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <div v-on="on">
                                {{utilsFunc.currencySym(item.currency)}} {{item.GSTExcludedAmt | thousandSeprator}}
                              </div>
                            </template>
                            <span>{{item.currency}} {{item.GSTExcludedAmt | thousandSeprator}}</span><br>
                            <span v-if="item.sgdGstIncluded">Estimate SGD: {{item.sgdGstIncluded}}</span>
                          </v-tooltip>
                        </span>
                      </td>
                    </template>
                    <template v-slot:[`item.campaignName`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'" style="min-width:130px!important">
                        <span v-if="item.campaignName">{{item.campaignName}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.clientName`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate text-start' : 'text-start'">
                        <span v-if="item.clientName">{{item.clientName}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.IONumber`]="{ item }">
                      <td class="text-center">
                        <span v-if="item.IONumber">{{item.IONumber}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.CC`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate' : 'text-start'">
                        <span v-if="item.CC">{{item.CC}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.duplicate`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate' : 'text-start'">
                        <div class="text-center">
                          <v-checkbox
                            class="mt-0 pr-4"
                            v-model="item.duplicate"
                            label=""
                            color="red"
                            :value="false"
                            hide-details
                            @change="changeDuplicate(item, item.duplicate)"
                          ></v-checkbox>
                        </div>
                      </td>
                    </template>
                    <template v-slot:[`item.estimationType`]="{ item }">
                      <td class="text-start">
                        <span>{{item.estimationType}}</span>
                        <p v-if="item.customType">({{item.customType}})</p>
                      </td>
                    </template>
                    <template v-slot:[`item.remarks`]="{ item }">
                      <td :class="item.duplicate ? 'text-duplicate' : 'text-start'">
                        <span v-if="item.remarks">{{item.remarks}}</span>
                      </td>
                    </template>
                    <template v-slot:[`item.invoices`]="{ item }">
                      <td class="text-center" style="width:120px;">
                        <div class="w-100 pt-1" v-if="item.invoices">
                          <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                              <v-btn
                              class="btn-payment-action"
                              color="warning"
                              dark
                              small
                              text
                              v-on="on">
                                View
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item
                                v-for="(invoice, i) in item.invoices"
                                :key="i"
                                :href="invoice.url"
                                target="_blank"
                              >
                                <v-list-item-content>{{invoice.name}}</v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </td>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <td class="text-center" style="width:120px;">
                        <div class="w-100 pt-1">
                          <!-- Edit Button -->
                          <v-btn @click="viewEditDialog(item)" color="warning" class="ims-action">
                            <v-icon small data-toggle="tooltip" data-placement="top" title="Edit Campaign">edit</v-icon>
                          </v-btn>
                        </div>
                      </td>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
    <create-cogs-estimate-modal
      :editItem="editCogsEstimate"
      v-model="createCogsEstimateDialog"
      :value="createCogsEstimateDialog"
      @created="getCogsEstimation"
    />
    <table-cols-show-hide-modal
      v-model="colSettingsDialog"
      title="COGS Estimation"
      :items="tableColsItems"
      @updated="updateTableCols"
    />
    <more-details-modal
      v-model="moreDetailsDialog"
      :value="moreDetailsDialog"
      :monthYearValues="revsForMonthYear"
      v-if="revsForMonthYear.length"
    />
    <total-summary-modal
      v-model="totalSummaryDialog"
      :value="totalSummaryDialog"
      :selectedCOGS="selectedCOGS"
    />
  </div>
</template>
<script>
import config from '@/config';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import SocialHandle from '@/components/scoped/custom/SocialHandle'
import CreateCogsEstimateModal from './CreateCogsEstimateModal';
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
import MoreDetailsModal from './MoreDetailsModal';
import TotalSummaryModal from './TotalSummaryModal';
import paymentAPIs from '../paymentAPIs';
import cogsEstimateConfig from './config';
import { mapState, mapGetters } from 'vuex'
import utils from '@/utils';
import sumBy from 'lodash/sumBy';
import orderBy from 'lodash/orderBy';
import userAPIs from '../../User/userAPIs';
const moment = require('moment')
export default {
  name: 'CogsEstimateDataTable',
  components: {
    SocialHandle,
    Loading,
    CreateCogsEstimateModal,
    TableColsShowHideModal,
    MoreDetailsModal,
    TotalSummaryModal
  },
  data() {
    return {
      headers: cogsEstimateConfig.tableHeaders,
      countries: cogsEstimateConfig.countries,
      utilsFunc: utils.func,
      items: [],
      editCogsEstimate: null,
      filter: '',
      filteredItems: [],
      selectedFilter: {
        startDate: '',
        endDate: '',
        searchDate: '',
        country: '',
        cc: '',
        batchOne: false,
        batchTwo: false,
        createdOnly: false,
        reload: false
      },
      searchDateCal: false,
      startDateCal: false,
      endDateCal: false,
      totalValues: {
        cogsEstimate: 0
      },
      isLoading: false,
      createCogsEstimateDialog: false,
      colSettingsDialog: false,
      moreDetailsDialog: false,
      totalSummaryDialog: false,
      colStatuses: {},
      currentMthCOGS: 0,
      nextMthCOGS: 0,
      startDate: '',
      endDate: '',
      dataTableFilteredItems: [],
      Users: [],
      CCUsers: [],
      revsForMonthYear: [],
      monthsData: [],
      selectedCOGS: []
    }
  },
  computed: {
    ...mapState({
      creatorCogsEstimate: state => state.payment.creatorCogsEstimate,
      currencyRates: state => state.payment.currencyRates
    }),
    ...mapGetters('payment', [
      'formatDate'
    ]),
    currentMonthLabel() {
      return moment().format('MMM YYYY')
    },
    nextMonthLabel() {
      return moment().add(1, 'months').format('MMM YYYY')
    },
    showFilterDate: function () {
      if (this.selectedFilter.startDate || this.selectedFilter.endDate) {
        let respDateStr = 'for '
        if (this.selectedFilter.startDate) {
          respDateStr += utils.func.formatCustomDate(this.selectedFilter.startDate, 'MMM YYYY')
        }
        if (this.selectedFilter.startDate && this.selectedFilter.endDate) {
          respDateStr += ' - '
        }
        if (this.selectedFilter.endDate) {
          respDateStr += utils.func.formatCustomDate(this.selectedFilter.endDate, 'MMM YYYY')
        }
        return respDateStr
      }
      return ''
    },
    computedHeaders() {
      if (localStorage.getItem('cogsEstimationCols')) {
        this.colStatuses = JSON.parse(localStorage.getItem('cogsEstimationCols'))
      } else {
        // default true if no col status in local storage
        this.headers.map(header => {
          this.colStatuses[header.value] = true
        })
      }
      return this.headers.filter(h => {
        if (this.colStatuses[h.value]) {
          return true
        }
        return false
      });
    }
  },
  async mounted() {
    await this.$store.dispatch('payment/getCurrencyRates')
    this.init()
    this.getAllUsers()
  },
  methods: {
    async init() {
      this.countries.unshift('Overseas')
      this.startDate = moment().format('YYYY') + '-01'
      this.endDate = moment().format('YYYY') + '-12'
      this.getCogsEstimation()
    },
    getCurrentMonthCOGS() {
      // this.isLoading = true
      // await this.$store.dispatch('payment/getCreatorCogsEstimate', {
      //   filters: {
      //     startDate: moment().format('YYYY-MM'),
      //     endDate: moment().format('YYYY-MM')
      //   }
      // })
      // let items = this.beautifyData()
      let items = this.filteredItems.filter(item => item.estimatedLiveDate === moment().format('YYYY-MM'))
      this.currentMthCOGS = Number(sumBy(items, (item) => {
        if (item.sgdGstIncluded) {
          return !isNaN(item.sgdGstIncluded) && item.sgdGstIncluded !== undefined && item.sgdGstIncluded !== 'undefined' ? Number(item.sgdGstIncluded || 0) : 0
        } else {
          return !isNaN(item.GSTExcludedAmt) && item.GSTExcludedAmt !== undefined && item.GSTExcludedAmt !== 'undefined' ? Number(item.GSTExcludedAmt || 0) : 0
        }
      }))
      this.currentMthCOGS = this.currentMthCOGS.toFixed(2)
      // this.isLoading = false
    },
    getNextMonthCOGS() {
      let items = this.filteredItems.filter(item => item.estimatedLiveDate === moment().add(1, 'months').format('YYYY-MM'))
      this.nextMthCOGS = Number(sumBy(items, (item) => {
        if (item.sgdGstIncluded) {
          return !isNaN(item.sgdGstIncluded) && item.sgdGstIncluded !== undefined && item.sgdGstIncluded !== 'undefined' ? Number(item.sgdGstIncluded || 0) : 0
        } else {
          return !isNaN(item.GSTExcludedAmt) && item.GSTExcludedAmt !== undefined && item.GSTExcludedAmt !== 'undefined' ? Number(item.GSTExcludedAmt || 0) : 0
        }
      }))
      this.nextMthCOGS = this.nextMthCOGS.toFixed(2)
      // this.isLoading = false
    },
    async getCogsEstimation() {
      this.isLoading = true
      this.selectedFilter.startDate = this.startDate
      this.selectedFilter.endDate = this.endDate
      await this.$store.dispatch('payment/getCreatorCogsEstimate', {
        filters: this.selectedFilter
      })
      this.searchFilter()
      this.calcTotalSummary(this.filteredItems)
      this.getCurrentMonthCOGS()
      this.getNextMonthCOGS()
      this.selectedFilter.reload = false
      this.isLoading = false
    },
    beautifyData() {
      this.creatorCogsEstimate = this.creatorCogsEstimate.map(inf => {
        if (inf.currency && inf.currency !== 'SGD') {
          inf.sgdAmt = utils.func.convertCurrency(inf.currency, Number(inf.amount || 0), this.currencyRates)
          inf.sgdGstIncluded = utils.func.convertCurrency(inf.currency, Number(inf.GSTExcludedAmt || 0), this.currencyRates)
        }
        inf.estimatedLiveDate = this.formatYM(inf.estimatedLiveDate)
        inf.selectedCOGS = []
        return inf
      })
      return Object.assign([], this.creatorCogsEstimate)
      // let items = []
      // this.creatorCogsEstimate.map(cogs => {
      //   let creators = []
      //   // merge with creators array and manually created new payouts record, amount
      //   if (cogs.creators) {
      //     creators = cogs.creators
      //     if (cogs.imported) {
      //       cogs.imported.map(p => {
      //         let matchIdx = creators.findIndex(c => c.handle === p.handle && c.campaign.id === p.campaign.id)
      //         // if (matchIdx !== -1) {
      //         //   creators[matchIdx].amount += Number(p.amount)
      //         //   creators[matchIdx].remarks = p.remarks
      //         // } else {
      //         //   p.created = true
      //         //   creators.push(p)
      //         // }
      //         if (matchIdx === -1) {
      //           p.created = true
      //           creators.push(p)
      //         }
      //       })
      //     }
      //   } else if (cogs.imported) {
      //     creators = cogs.imported.map(ip => {
      //       ip.created = true
      //       return ip
      //     })
      //   }
      //   if (creators.length) {
      //     items.push(...creators)
      //   }
      // })
      // items = items.map(item => {
      //   if (item.campaign) {
      //     item.campaignName = item.campaign.name
      //     item.clientName = item.campaign.clientName
      //     item.IONumber = item.campaign.IONumber
      //   }
      //   if (item.amount && !isNaN(item.amount)) {
      //     item.amount = item.amount.toFixed(2)
      //   }
      //   return item
      // })
      // return items
    },
    // resetFilter() {
    //   // reset filters
    //   this.selectedFilter = {
    //     startDate: '',
    //     endDate: ''
    //   }
    //   this.filter = ''
    //   this.getCogsEstimation()
    // },
    searchFilter() {
      this.items = this.beautifyData()
      this.filteredItems = this.creatorCogsEstimate.map(i => i)
      this.filteredItems = orderBy(this.filteredItems, ['estimatedLiveDate'], ['desc'])
      if (this.selectedFilter.cc) {
        this.filteredItems = this.filteredItems.filter(f => f.POC && f.POC.includes(this.selectedFilter.cc))
      }
      if (this.selectedFilter.createdOnly) {
        this.filteredItems = this.filteredItems.filter(f => f.created)
      }
      this.getTotalSummary()
      this.monthsData = this.generateMonthArray()
      this.monthsData = this.monthsData.map(m => {
        m.data = this.filteredItems.filter(fm => fm.estimatedLiveDate === m.month)
        return m
      })
      this.monthsData = this.monthsData.filter(f => f.data.length)
    },
    // searchStartMonthOk() {
    //   this.startDateCal = false
    //   this.getCogsEstimation()
    // },
    // async cancelStartMonth() {
    //   this.startDateCal = false
    //   this.selectedFilter.startDate = ''
    //   this.getCogsEstimation()
    // },
    // searchEndMonthOk() {
    //   this.endDateCal = false
    //   this.getCogsEstimation()
    // },
    // async cancelEndMonth() {
    //   this.endDateCal = false
    //   this.selectedFilter.endDate = ''
    //   this.getCogsEstimation()
    // },
    resetTotalValues() {
      this.totalValues = {
        cogsEstimate: 0
      }
    },
    calcTotalSummary(items = []) {
      this.resetTotalValues()
      if (!items.length) {
        return;
      }
      this.totalValues.cogsEstimate = Number(sumBy(items, (item) => {
        if (!item.duplicate) {
          let otherAmts = 0
          let gstIncluded = 0
          otherAmts += item.cogsRelated ? Number(item.cogsRelated) : 0
          otherAmts += item.internalClaims ? Number(item.internalClaims) : 0
          otherAmts += item.logistics ? Number(item.logistics) : 0
          otherAmts += item.otherAdjustment ? Number(item.otherAdjustment) : 0
          if (item.currency && item.currency !== 'SGD') {
            gstIncluded = utils.func.convertCurrency(item.currency, item.GSTExcludedAmt, this.currencyRates)
          } else {
            gstIncluded = Number(item.GSTExcludedAmt)
          }
          return Number(gstIncluded) - otherAmts
        }
      }))
      this.totalValues.cogsEstimate = this.totalValues.cogsEstimate.toFixed(2)
    },
    getFiltered() {
      this.$nextTick(() => {
        if (this.$refs.CreatorCogsTable.$children) {
          this.calcTotalSummary(this.$refs.CreatorCogsTable.$children[0].filteredItems)
          this.dataTableFilteredItems = this.$refs.CreatorCogsTable.$children[0].filteredItems
        }
      });
    },
    openCreateCogsEstimateModal() {
      this.editCogsEstimate = null
      this.createCogsEstimateDialog = true
    },
    openMoreDetailsDialog() {
      this.moreDetailsDialog = true
    },
    openTotalSummaryDialog(selectedCOGS) {
      this.selectedCOGS = selectedCOGS
      this.totalSummaryDialog = false
      this.totalSummaryDialog = true
    },
    remove(item) {
      this.selectedFilter.country.splice(this.selectedFilter.country.indexOf(item), 1)
      this.selectedFilter.country = [...this.selectedFilter.country]
    },
    reload() {
      this.selectedFilter.reload = true
      this.getCogsEstimation()
    },
    openColSettingsModal() {
      this.tableColsItems = []
      let tmpStatuses = {}
      if (Object.keys(this.colStatuses).length) {
        tmpStatuses = Object.assign({}, this.colStatuses)
      } else {
        this.headers.map(header => {
          tmpStatuses[header.value] = true
        })
      }
      for (const [key, value] of Object.entries(tmpStatuses)) {
        let header = this.headers.find(item => item.value === key)
        if (header) {
          this.tableColsItems.push({
            title: header.text,
            key,
            value
          })
        }
      }
      this.colSettingsDialog = true
    },
    updateTableCols(items) {
      let columns = this.colStatuses
      items.map(item => {
        columns[item.key] = item.value
      })
      localStorage.setItem('cogsEstimationCols', JSON.stringify(columns))
      this.colStatuses = Object.assign({}, columns)
      this.colSettingsDialog = false
    },
    viewEditDialog(item) {
      this.editCogsEstimate = Object.assign({}, item)
      this.createCogsEstimateDialog = true
    },
    async changeDuplicate(item, status) {
      let formData = new FormData();
      let saveData = {
        id: item.id,
        duplicate: status,
        liveDate: item.liveDate
      }
      formData.append('data', JSON.stringify(saveData))
      await this.$store.dispatch('payment/createCogsEstimate', formData)
      this.calcTotalSummary(this.filteredItems)
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    downloadCogsEstimateRpt() {
      this.isLoading = true
      let filters = Object.assign({}, this.selectedFilter)
      // use filtered report ids to apply keyword search filter
      filters.reportIds = this.filteredItems.map(item => item.id)
      paymentAPIs
        .downloadCogsEstimateRpt(filters)
        .then(() => {
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          console.log('error in downloading cogs estimation report', error);
        })
    },
    async getAllUsers() {
      // Get all Users
      let response = await userAPIs.getAllUsersByRole(`${config.userRoles.SUPER_ADMIN_HIGH},${config.userRoles.SUPER_ADMIN_LOW},${config.userRoles.COMPANY_ADMIN_HIGH},${config.userRoles.COMPANY_ADMIN_LOW},${config.userRoles.AD_STRATEGIST},${config.userRoles.FINANCE},${config.userRoles.ACCOUNT_MANAGER}`)
      if (response) {
        this.Users = response.users
        this.Users = this.Users.map(u => {
          u.name = `${u.firstName}`
          return u
        })
        this.CCUsers = this.Users.filter(c => c.role === config.userRoles.AD_STRATEGIST)
        this.CCUsers.unshift({
          id: '',
          name: 'All CC'
        })
      }
    },
    getTotalSummary() {
      let shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      let currentYear = moment().format('YYYY')
      let matchMonths = shortMonths.map(m => `${m} ${currentYear}`)
      let revsForMonthYear = matchMonths.map(m => {
        return {
          month: m,
          totalAmt: 0
        }
      })
      // set total cogs
      this.filteredItems.map(item => {
        let createdMonth = moment(item.estimatedLiveDate).format('MMM YYYY')
        let revMYIdx = revsForMonthYear.findIndex(rev => rev.month === createdMonth)
        if (revMYIdx !== -1) {
          if (item.sgdGstIncluded) {
            revsForMonthYear[revMYIdx].totalAmt += !isNaN(item.sgdGstIncluded) && item.sgdGstIncluded !== undefined && item.sgdGstIncluded !== 'undefined' ? Number(item.sgdGstIncluded || 0) : 0
          } else {
            revsForMonthYear[revMYIdx].totalAmt += !isNaN(item.GSTExcludedAmt) && item.GSTExcludedAmt !== undefined && item.GSTExcludedAmt !== 'undefined' ? Number(item.GSTExcludedAmt || 0) : 0
          }
        }
      })
      revsForMonthYear = revsForMonthYear.map(rm => {
        if (rm.totalAmt) {
          rm.totalAmt = Number(rm.totalAmt).toFixed(2)
        }
        return rm
      })
      this.revsForMonthYear = revsForMonthYear
    },
    formatYM(date) {
      return moment(date).format('YYYY-MM')
    },
    formatDMY(date) {
      if (date.includes('00:00:00')) return ''
      return moment(date).format('DD/MM/YYYY')
    },
    formatTitle(date) {
      if (!date) return
      return moment(date).format('MMM YYYY')
    },
    generateMonthArray() {
      // Function to generate month array from December to January of the next year
      const monthArray = [];
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const startMonth = 12; // December
      // Loop from December to January of the next year
      for (let i = 0; i < 13; i++) {
        const year = (i === 0) ? currentYear + 1 : currentYear; // January belongs to the next year
        const month = (startMonth - i + 12) % 12 || 12; // Adjust month (1-12)
        const monthString = `${year}-${month.toString().padStart(2, '0')}`; // Format YYYY-MM
        monthArray.push({ month: monthString, data: [] });
      }
      // Sort the array in descending order
      monthArray.sort((a, b) => b.month.localeCompare(a.month));
      return monthArray;
    },
    openTotalSummaryModal(selectedCOGS) {
      this.selectedCOGS = Object.assign([], selectedCOGS)
      this.totalSummaryDialog = true
    }
  }
}
</script>
<style scoped>
  .date-divider {
    width: 30px;
    text-align: center;
    padding-top: 10px;
  }
  .text-duplicate span {
    text-decoration: line-through;
  }
</style>
<style>
  .creator-cogs-table tbody td {
    min-width: 120px
  }
  .creator-cogs-table .text-duplicate a {
    text-decoration: line-through;
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?16a1e280